'use strict';

/**
 * @classname TabSelect
 * @classdesc 求人詳細のタブの切り替え
 */
export default class TabSelect {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 * @param {instance} controller - controller オブジェクト
	 */
	constructor($e) {
		console.log('TabSelect.constructor');
		this._$e = $e;
		$e.on('click', () => this.onClick());
	};


	/**
	 * クリックイベントのコールバック
	 *
	 * @memberof TabSelect
	 * @return {undefined}
	 */
	onClick() {
		console.log('TabSelect.onClick');
		if (!this._$e.hasClass('active')) {
			$('.tab--job-detail .anchor').removeClass('active');
			this._$e.addClass('active');
		}
	};
};